import { SwitchButton } from "@smartsuite/react-ui/lib";

import type { InputConfig } from "@smartsuite/automation-engine-api";
import { useEffect, useState } from "react";
import * as S from "./style";
import { translateIfPresent } from "../../../../../../locales/i18n";

export const WhiteToggleType: React.FC<{
  options: Array<{
    value: string;
    label: string;
    subLabel?: string;
  }>;
  config: InputConfig;
  onChange: (input: InputConfig) => void;
}> = ({ options, config, onChange }) => {
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    if (
      config.value?.values[0]?.value.oneofKind === "string" &&
      config.value?.values[0]?.value.string !== ""
    ) {
      setSelectedOption(config.value?.values[0]?.value.string);
    } else {
      // Set default value if not set
      onChange({
        ...config,
        value: {
          values: [
            {
              value: {
                oneofKind: "string",
                string: options[0].value,
              },
            },
          ],
        },
      });
    }
  }, [config]);

  const hasSubLabel = options.length > 0 && options[0].subLabel !== undefined;

  return (
    <S.SwitchWrapper $hasSubLabel={hasSubLabel}>
      <SwitchButton
        options={options.map((option) => ({
          value: option.value,
          label: translateIfPresent("caption." + option.label, option.label),
          subLabel: option.subLabel
            ? translateIfPresent("caption." + option.subLabel, option.subLabel)
            : undefined,
        }))}
        currentValue={selectedOption ?? ""}
        styles={S.stylesWhiteSwitchButton}
        onChange={(value) => {
          onChange({
            ...config,
            value: {
              values: [
                {
                  value: {
                    oneofKind: "string",
                    string: String(value),
                  },
                },
              ],
            },
          });
        }}
      />
    </S.SwitchWrapper>
  );
};
